module.exports = __webpack_public_path__ + "img/精致美型--瘦鼻gif.b9cc1116.gif";